/*
 * @Author: liyxt
 * @Date: 2019-10-14 15:12:41
 * @LastEditors: liyxt
 * @LastEditTime: 2019-10-14 15:12:41
 * @Description: file content
 */
import React, { Component } from 'react';
import { Element } from 'react-scroll';

/**
 * Scroll组件的参数描述
 * @ignore
 * @memberof BaseScroll
 * @component ScrollElement
 * @property {string} name - 滚动元素的名称，唯一
 */
export default class ScrollElement extends Component {
    render() {
        return <Element {...this.props} className={`nc-scrollElement-wrap ${this.props.className}`} />;
    }
}
